export class Trade {

  orderId: string;
  sixLetterCode: string;
  quantity: number;
  priceBid: number;
  priceAsk: number;
  direction: string;
  currentMarket: number;
  amount: number;
  from: string;
  ocoLinkId: number | null;

  constructor(orderId: string, sixLetterCode: string, quantity: number, priceBid: number, priceAsk: number, currentMarket: number, amount: number, from: string, direction: string = 'LEND', ocoLinkId = null) {
    this.orderId = orderId;
    this.sixLetterCode = sixLetterCode;
    this.quantity = quantity;
    this.priceBid = priceBid;
    this.priceAsk = priceAsk;
    this.direction = direction;
    this.currentMarket = currentMarket;
    this.amount = amount;
    this.from = from;
    this.ocoLinkId = ocoLinkId;
  }
}
